import SpinnerIcon from '@fec/frontend/elements/loading/spinner/Spinner';

import './Spinner.scss';

export const Spinner = () => {
  return (
    <div className="srf-comments-spinner">
      <SpinnerIcon />
    </div>
  );
};
